import { c as _c } from "react/compiler-runtime";
import { getClientSideURL } from '@/lib/utils/getURL';
import { Button } from '@tallinn-arvudes/ui/tallinn-design/Button';
import { useRouter } from 'next/navigation';
import { type User } from 'payload';
import React, { type Dispatch, type ReactNode, type SetStateAction } from 'react';
export type AdminBarProps = {
  cmsURL?: string;
  adminPath?: string;
  apiPath?: string;
  collection?: string;
  collectionLabels?: {
    singular?: string;
    plural?: string;
  };
  id?: string;
  logo?: ReactNode;
  className?: string;
  onAuthChange?: (user: User | null) => void;
  preview?: boolean;
  onPreviewExit?: () => void;
  user: User | null;
};
type AdminLinkProps = {
  children: ReactNode;
} & ({
  onClick?: () => void | Promise<void>;
  href?: never;
} | {
  onClick?: never;
  href: string;
});
const AdminLink = t0 => {
  const $ = _c(4);
  const {
    onClick,
    href,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== href || $[2] !== onClick) {
    t1 = <Button href={href} target="_blank" rel="noopener noreferrer" compact={true} onClick={onClick} className="m-1 md:m-0">{children}</Button>;
    $[0] = children;
    $[1] = href;
    $[2] = onClick;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export const AdminBarContent: React.FC<Omit<AdminBarProps, 'onAuthChange'> & {
  setOpen: Dispatch<SetStateAction<boolean>>;
}> = props => {
  const $ = _c(42);
  const {
    cmsURL: t0,
    adminPath: t1,
    collection,
    collectionLabels,
    id,
    logo,
    user,
    preview,
    setOpen
  } = props;
  const cmsURL = t0 === undefined ? "http://localhost:3000" : t0;
  const adminPath = t1 === undefined ? "/admin" : t1;
  const router = useRouter();
  let t2;
  if ($[0] !== cmsURL || $[1] !== router || $[2] !== setOpen) {
    t2 = async () => {
      await fetch(`${cmsURL}/api/users/logout`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        }
      });
      router.refresh();
      setOpen(false);
    };
    $[0] = cmsURL;
    $[1] = router;
    $[2] = setOpen;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const logout = t2;
  const previewUrl = _temp;
  if (user) {
    const {
      email,
      id: userID
    } = user;
    const t3 = `${cmsURL}${adminPath}`;
    const t4 = logo || " CMS";
    let t5;
    if ($[4] !== t3 || $[5] !== t4) {
      t5 = <AdminLink href={t3}>{t4}</AdminLink>;
      $[4] = t3;
      $[5] = t4;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    const t6 = `${cmsURL}${adminPath}/collections/users/${userID}`;
    const t7 = email || "Profiil";
    let t8;
    if ($[7] !== t7) {
      t8 = <span>{t7}</span>;
      $[7] = t7;
      $[8] = t8;
    } else {
      t8 = $[8];
    }
    let t9;
    if ($[9] !== t6 || $[10] !== t8) {
      t9 = <AdminLink href={t6}>{t8}</AdminLink>;
      $[9] = t6;
      $[10] = t8;
      $[11] = t9;
    } else {
      t9 = $[11];
    }
    let t10;
    if ($[12] !== adminPath || $[13] !== cmsURL || $[14] !== collection || $[15] !== collectionLabels?.singular || $[16] !== id) {
      t10 = collection && id && <a href={`${cmsURL}${adminPath}/collections/${collection}/${id}`} target="_blank" rel="noopener noreferrer">{`Muuda ${collectionLabels?.singular || "lehte"}`}</a>;
      $[12] = adminPath;
      $[13] = cmsURL;
      $[14] = collection;
      $[15] = collectionLabels?.singular;
      $[16] = id;
      $[17] = t10;
    } else {
      t10 = $[17];
    }
    let t11;
    if ($[18] !== adminPath || $[19] !== cmsURL || $[20] !== collection || $[21] !== collectionLabels?.singular) {
      t11 = collection && <AdminLink href={`${cmsURL}${adminPath}/collections/${collection}/create`}>{`Loo uus ${collectionLabels?.singular || "leht"}`}</AdminLink>;
      $[18] = adminPath;
      $[19] = cmsURL;
      $[20] = collection;
      $[21] = collectionLabels?.singular;
      $[22] = t11;
    } else {
      t11 = $[22];
    }
    let t12;
    if ($[23] !== preview || $[24] !== setOpen) {
      t12 = !preview && <AdminLink onClick={() => {
        fetch(previewUrl()).then(() => {
          setOpen(false);
          window.location.reload();
        });
      }}>Mine eelvaatesse</AdminLink>;
      $[23] = preview;
      $[24] = setOpen;
      $[25] = t12;
    } else {
      t12 = $[25];
    }
    let t13;
    if ($[26] !== preview || $[27] !== router || $[28] !== setOpen) {
      t13 = preview && <AdminLink onClick={() => {
        fetch("/api/exit-preview").then(() => {
          router.refresh();
          setOpen(false);
        });
      }}>Välju eelvaatest</AdminLink>;
      $[26] = preview;
      $[27] = router;
      $[28] = setOpen;
      $[29] = t13;
    } else {
      t13 = $[29];
    }
    let t14;
    if ($[30] !== t10 || $[31] !== t11 || $[32] !== t12 || $[33] !== t13) {
      t14 = <div>{t10}{t11}{t12}{t13}</div>;
      $[30] = t10;
      $[31] = t11;
      $[32] = t12;
      $[33] = t13;
      $[34] = t14;
    } else {
      t14 = $[34];
    }
    let t15;
    if ($[35] !== logout) {
      t15 = <AdminLink onClick={logout}>Logi välja</AdminLink>;
      $[35] = logout;
      $[36] = t15;
    } else {
      t15 = $[36];
    }
    let t16;
    if ($[37] !== t14 || $[38] !== t15 || $[39] !== t5 || $[40] !== t9) {
      t16 = <div className="p-2 text-white flex flex-wrap w-full md:space-x-2">{t5}{t9}{t14}{t15}</div>;
      $[37] = t14;
      $[38] = t15;
      $[39] = t5;
      $[40] = t9;
      $[41] = t16;
    } else {
      t16 = $[41];
    }
    return t16;
  }
  return null;
};
function _temp() {
  const path = encodeURIComponent(window.location.pathname);
  return `${getClientSideURL()}/api/preview?path=${path}&manual=true`;
}